'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import { Column, Row } from 'Components/UI'

import { BlogQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import Hero from './hero'
import Post from './post'

type Props = {
  data?: BlogQuery
}

function BlogPage({ data }: Props) {
  if (!data?.blog) return null

  return (
    <PageWrapper>
      <Header />

      <Column alignCenter as="main" fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />

        <Hero data={data.blog} />

        <Post data={data.blog} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default BlogPage
